import React, { Component } from "react";

import PropTypes from "prop-types";
import { Checkbox } from "antd";

class KpiCheckbox extends Component {
	constructor(props) {
		super(props);
	}

	/**
	 * Check dependencies
	 */
	addDependencies() {
		const { kpi, kpisList, addKpi, locationType, statement } = this.props;
		const dependencies = kpi.kpi_dependencies || [];

		for (let i = 0; i < dependencies.length; i++) {
			const dependency = dependencies[i];
			for (let j = 0; j < kpisList.length; j++) {
				const kpisListElement = kpisList[j];
				if (
					kpisListElement.id == dependency &&
					kpisListElement.survey_display
				) {
					addKpi({
						locationType: locationType,
						statement: statement,
						kpi: kpisListElement,
					});
				}
			}
		}
	}

	/**
	 * Check if kpi can be unchecked
	 * statement.kpis must not contains kpi dependencies checked
	 */
	isUncheckable() {
		const { kpi, kpisSelected } = this.props;

		for (let i = 0; i < kpisSelected.length; i++) {
			const kpisCheckedElement = kpisSelected[i];
			const checkedElementDependencies =
				kpisCheckedElement.kpi_dependencies || [];
			if (checkedElementDependencies.indexOf(parseInt(kpi.id)) !== -1) {
				return false;
			}
		}
		return true;
	}

	render() {
		const { checked, addKpi, removeKpi, display } = this.props;

		//if(!display) return null;
		return (
			<Checkbox
				checked={checked}
				onChange={e => {
					const isChecked = e.target && e.target.checked;
					if (isChecked) {
						this.addDependencies();
						addKpi();
					} else {
						if (this.isUncheckable()) {
							removeKpi();
						}
					}
				}}
			/>
		);
	}
}

KpiCheckbox.propTypes = {
	addKpi: PropTypes.func.isRequired,
	removeKpi: PropTypes.func.isRequired,
	locationType: PropTypes.object.isRequired,
	statement: PropTypes.object.isRequired,
	kpi: PropTypes.object.isRequired,
	checked: PropTypes.bool.isRequired,
};

export default KpiCheckbox;



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepActionsKpi/SurveyStepActionsKpiTabElements/KpiCheckbox.js